import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Bookstore from "@/pages/Bookstore";
import BookDetail from "@/pages/BookDetail";
import Submit from "@/pages/Submit";
import Services from "@/pages/Services";
import Authors from "@/pages/Authors";
import TCPI from "@/pages/TCPI";
import Foundation from "@/pages/Foundation";
import Media from "@/pages/Media";
import Academy from "@/pages/Academy";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/bookstore" element={<Bookstore />} />
            <Route path="/book/:slug" element={<BookDetail />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/services" element={<Services />} />
            <Route path="/authors" element={<Authors />} />
            <Route path="/tcpi" element={<TCPI />} />
            <Route path="/foundation" element={<Foundation />} />
            <Route path="/media" element={<Media />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
